import { urlAPI } from 'src/config';
import { END, eventChannel, EventChannel } from 'redux-saga';
import { POWERBI_WORKSPACE_PROGRESS, POWERBI_WORKSPACE_SUCCESS, POWERBI_WORKSPACE_ERROR } from 'src/redux/actionTypes';
import { obtemFirebaseToken } from 'src/integracoes/servicos/mongo-atlas/autenticacao';

export const criarPowerBiWorkspaceChannel = (empId: string, versaoModelo?: string): EventChannel<any> => {
  return eventChannel((emitter) => {
    let eventSource: EventSource;

    obtemFirebaseToken().then((token) => {
      const url = `${urlAPI}/powerbi/${empId}/${versaoModelo}/criar-workspace/stream?token=${token}`;
      eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.status === 'processing') {
          emitter({ type: POWERBI_WORKSPACE_PROGRESS, payload: data });
        } else if (data.status === 'completed') {
          emitter({ type: POWERBI_WORKSPACE_SUCCESS, payload: data });
          emitter(END);
        } else if (data.status === 'error') {
          emitter({ type: POWERBI_WORKSPACE_ERROR, payload: data.message });
          emitter(END);
        }
      };

      eventSource.onerror = () => {
        emitter({ type: POWERBI_WORKSPACE_ERROR, payload: 'Falha na conexão com o servidor' });
        emitter(END);
      };
    }).catch(() => {
      emitter({ type: POWERBI_WORKSPACE_ERROR, payload: 'Falha ao obter token de autenticação' });
      emitter(END);
    });

    return () => {
      if (eventSource) eventSource.close();
    };
  });
};

export const atualizarPowerBiWorkspaceChannel = (empId: string, versaoModelo?: string): EventChannel<any> => {
  return eventChannel((emitter) => {
    let eventSource: EventSource;

    obtemFirebaseToken().then((token) => {
      const url = `${urlAPI}/powerbi/${empId}/${versaoModelo}/atualiza-workspace/stream?token=${token}`;
      eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.status === 'processing') {
          emitter({ type: POWERBI_WORKSPACE_PROGRESS, payload: data });
        } else if (data.status === 'completed') {
          emitter({ type: POWERBI_WORKSPACE_SUCCESS, payload: data });
          emitter(END);
        } else if (data.status === 'error') {
          emitter({ type: POWERBI_WORKSPACE_ERROR, payload: data.message });
          emitter(END);
        }
      };

      eventSource.onerror = () => {
        emitter({ type: POWERBI_WORKSPACE_ERROR, payload: 'Falha na conexão com o servidor' });
        emitter(END);
      };
    }).catch(() => {
      emitter({ type: POWERBI_WORKSPACE_ERROR, payload: 'Falha ao obter token de autenticação' });
      emitter(END);
    });

    return () => {
      if (eventSource) eventSource.close();
    };
  });
};

export const criarNovaVersaoWorkspaceChannel = (workspaceId: string, datasetId: string, reportIdGeral: string, novaVersao: string): EventChannel<any> => {
  return eventChannel((emitter) => {
    let eventSource: EventSource;

    obtemFirebaseToken().then((token) => {
      const url = `${urlAPI}/powerbi/nova-versao-workspace/stream?workspaceId=${workspaceId}&datasetId=${datasetId}&reportIdGeral=${reportIdGeral}&novaVersao=${novaVersao}&token=${token}`;
      eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.status === 'processing') {
          emitter({ type: POWERBI_WORKSPACE_PROGRESS, payload: data });
        } else if (data.status === 'completed') {
          emitter({ type: POWERBI_WORKSPACE_SUCCESS, payload: data });
          emitter(END);
        } else if (data.status === 'error') {
          emitter({ type: POWERBI_WORKSPACE_ERROR, payload: data.message });
          emitter(END);
        }
      };

      eventSource.onerror = () => {
        emitter({ type: POWERBI_WORKSPACE_ERROR, payload: 'Falha na conexão com o servidor' });
        emitter(END);
      };
    }).catch(() => {
      emitter({ type: POWERBI_WORKSPACE_ERROR, payload: 'Falha ao obter token de autenticação' });
      emitter(END);
    });

    return () => {
      if (eventSource) eventSource.close();
    };
  });
};
